import EmblaCarousel from '@theme/embla-carousel';
import EmblaCarouselAutoScroll from '@theme/embla-carousel-auto-scroll';
class VideoAutoScroller extends HTMLElement {
  constructor() {
    super();
    this.viewport = null;
    this.emblaApi = null;
    this.slides = [];

  }

  connectedCallback() {
    this.#init();
  }

  disconnectedCallback() {

  }
  #init() {
    try {
      this.viewport = this.querySelector('.embla__viewport');
      if (!this.viewport) {
        throw new Error('VideoAutoScroller: Embla container or viewport not found');
      }
      this.emblaApi = EmblaCarousel(this.viewport, { loop: true }, [
        EmblaCarouselAutoScroll({ playOnInit: true, stopOnMouseEnter: true, stopOnInteraction: false, speed: .5 })
      ]);
    } catch (error) {
      console.error('VideoAutoScroller: EmblaCarousel init failed', error);
    }
    this.slides = this.viewport.querySelectorAll(".embla__slide");

    this.slides.forEach((slide) => {
      const card = slide.querySelector(".video-auto-scroller__card");
      if (!(card instanceof HTMLElement)) return;

      card.addEventListener(
        "mouseenter",
        () => {
          card.classList.add("is-hover");
          this.#activateCardMedia(card);
        }
      );

      card.addEventListener(
        "mouseleave",
        () => {
          card.classList.remove("is-hover");
          this.#resetCardMedia(card);
        }
      );
    });
  }
  /**
   * @param {HTMLElement} card
   */
  #activateCardMedia(card) {
    const video = card.querySelector("video.video-auto-scroller__video");
    if (video) {
      video.play().catch(() => {});
      return;
    }

    const root = card.querySelector(".video-auto-scroller__iframe-root");
    if (!(root instanceof HTMLElement)) return;

    const type = root.dataset.externalType;
    const id = root.dataset.externalId;
    if (!type || !id || root.querySelector("iframe")) return;

    let src = "";
    if (type === "youtube") {
      const enc = encodeURIComponent(id);
      src = `https://www.youtube.com/embed/${enc}?autoplay=1&mute=1&playsinline=1&loop=1&playlist=${enc}`;
    } else if (type === "vimeo") {
      src = `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1&muted=1&loop=1`;
    }
    if (!src) return;

    const iframe = document.createElement("iframe");
    iframe.className = "video-auto-scroller__iframe";
    iframe.setAttribute("allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture");
    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute("loading", "eager");
    const title = this.dataset.iframeTitle?.trim();
    iframe.title = title || "Video";
    iframe.src = src;
    root.appendChild(iframe);
  }

  /**
   * @param {HTMLElement} card
   */
  #resetCardMedia(card) {
    const video = card.querySelector("video.video-auto-scroller__video");
    if (video) {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (_e) {
        // ignore
      }
    }
    const root = card.querySelector(".video-auto-scroller__iframe-root");
    if (root) root.innerHTML = "";
  }
}

customElements.define('video-auto-scroller', VideoAutoScroller);
